import React from "react";
import { Button, Popover } from "@mui/material";

export interface ClickPopoverProps {
  anchorOrigin?: any;
  button?: any;
  children: React.ReactElement;
  trigger?: React.ReactNode;
  onOpen?: () => void;
  transformOrigin?: any;
  closeCallback?: Function;
}

export function ClickPopover({
  anchorOrigin = {
    vertical: "bottom",
    horizontal: "left",
  },
  button = {},
  children,
  onOpen,
  transformOrigin = {
    vertical: "top",
    horizontal: "center",
  },
  trigger,
  closeCallback,
}: ClickPopoverProps) {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
    if (onOpen) {
      onOpen();
    }
  };

  const handleClose = () => {
    if (closeCallback) closeCallback();
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const childrenWithNewProps = React.cloneElement(children, {
    onClose: handleClose,
    open,
  });

  return (
    <>
      <Button aria-describedby={id} onClick={handleClick} {...button}>
        {trigger ?? ""}
      </Button>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        transformOrigin={transformOrigin}
      >
        {childrenWithNewProps}
      </Popover>
    </>
  );
}
